








import _ from 'lodash'
import {Component, Vue} from 'vue-property-decorator'
import SurveyListDate from './SurveyListDate.vue'
import {Mutation, Action} from 'vuex-class'
import {Task} from '@/store/types'
import SurveyModel from '@/classes/SurveyModel'

@Component({
  components: {
    SurveyListDate,
  },
})

export default class SurveyList extends Vue {

  @Action('getTaskList') public getTaskList: any
  @Mutation('setLoader') public setLoader!: any

  public confirmedSurveys: Task[] = []

  get groupedByDate() {
    return _.groupBy(_.orderBy(this.confirmedSurveys, 'date'), 'date')
  }

  public created() {
    this.setLoader(true)
    this.getTaskList([`status=${SurveyModel.STATUS.ACTIVE}`])
      .then((response: Task[]) => {
        this.confirmedSurveys = response
        this.setLoader(false)
      })

  }
}
